

import { debug, Emittery, debounce } from "/vodalys/.jslibs";
const log = debug('AutomuteResolver:main*')
// debug.enable('AutomuteResolver:*')


export class AutomuteResolverService {

     

    private debouncedNotify: () => void

    private node: Node
    private unmuteActions = [] as (() => void)[] 
    private weakActionMap = new WeakMap<() => void, HTMLMediaElement>()
    private eventEmitter = new Emittery<{
        unmutesAvailable: number
    }>()

    constructor(node: Node = globalThis.document) {
        this.node = node

        this.debouncedNotify = debounce(() => this.eventEmitter.emit('unmutesAvailable', this.unmuteActions.length))
        

        if (!globalThis.document.body) {
            // body not initialized yet, its the best case to observe video addition and denied autoplay
            globalThis.document.addEventListener('DOMContentLoaded', () => {
                log('AutomuteResolverService DOMContentLoaded')
                this.observeAutomutedAttributesAddition();
            });
        } else {
            // body already initialized, we can observe future video addition and tri to do stuff with already existing videos
            this.observeAutomutedAttributesAddition();
            this.handleExistingVideos();
        }



    }

    hasUnmutesAvailable() {
        return this.unmuteActions.length
    }

    handleExistingVideos() {
        const videos = document.querySelectorAll('video')
        videos.forEach((video) => {
            if (!video.getAttribute('automuted') || video.getAttribute('realmute')) return

            this.registerUnmuteAction(video)
        })
    }

    registerUnmuteAction(video?: HTMLMediaElement) {

        log('registerUnmuteAction', video)
        const action = () => {
            log('automuted, unmute', video, video.muted, video.volume)
            video.removeAttribute('automuted')
            video.muted = false
        }
        this.unmuteActions.push(action)
        this.weakActionMap.set(action, video)
        this.debouncedNotify()
    }

    
    unregisterUnmuteAction(video?: HTMLMediaElement) {

        log('unregisterUnmuteAction', video)

        const action = this.unmuteActions.find(action => this.weakActionMap.get(action) === video)
        if (!action) return

        log('splice unmuteActions')
        this.unmuteActions.splice(this.unmuteActions.indexOf(action), 1)


        this.debouncedNotify()
    }

    unmuteAll() {
        log(`unmuteAll, now unmuting ${this.unmuteActions.length} videos`)
        while (this.unmuteActions.length > 0) {
            const unmuteCallback = this.unmuteActions.pop()
            unmuteCallback()
        }
        this.eventEmitter.emit('unmutesAvailable', this.unmuteActions.length)

    }

    observeAutomutedAttributesAddition() {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    
                    const video = mutation.target as HTMLVideoElement
                    
                    // si la video est deja mute, on ne fait rien
                    if (video.getAttribute('realmute')) return

                    // si l'attribut automuted est suprimer on deregister l'unmute
                    if (!video.getAttribute('automuted')) {
                        log('The "automuted" attribute was remove from the video element.');
                        return this.unregisterUnmuteAction(video)
                    }
                    
                    log('The "automuted" attribute was add to the video element.');
                    this.registerUnmuteAction(video)
                }
            }
        });


        observer.observe(globalThis.document.body, { childList: false, subtree: true, attributes: true, attributeFilter: ['automuted'] });
    }
}



const weakMapAutoresolver = new WeakMap<object, AutomuteResolverService>()

globalThis.getAutomuteResolverService = function getAutomuteResolverService(component: object, node: Node = globalThis.document) {

    if (!weakMapAutoresolver.has(component)) {
        const automuteResolverService = new AutomuteResolverService(node)
        weakMapAutoresolver.set(component, automuteResolverService)
    }

    return weakMapAutoresolver.get(component)
}

// const muteResolver = globalThis.getAutomuteResolverService()